import React from 'react';
import './App.css';
import { ThemeProvider } from './context/ThemeContext';
import { ExperienceProvider } from './context/ExperienceContext';
import Layout from './components/common/Layout/Layout';
import Hero from './components/sections/Hero/Hero';
import About from './components/sections/About/About';
import Skills from './components/sections/Skills/Skills';
import Projects from './components/sections/Projects/Projects';
import Experience from './components/sections/Experience/Experience';
import Contact from './components/sections/Contact/Contact';
function App() {
  return (
    <ThemeProvider>
      <ExperienceProvider>
        <div className="App">
          <Layout>
          {/* Hero Section - Fully Built */}
          <Hero />
          
          {/* Placeholder sections - to be built next */}
          <About />
          <Skills />
          <Projects />
          <Experience />
            <Contact />
          </Layout>
        </div>
      </ExperienceProvider>
    </ThemeProvider>
  );
}

export default App;